import React, { useEffect, useState } from 'react';

import { ArtistSearchResult } from '../page/Search.jsx';

function Trending() {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    fetchArtists();
  }, []);

  function fetchArtists() {
    Artcloud.api.get(Artcloud.url.vendor.marketplace.artists.get(),
      { order: 'popularity' },
      function (responseData) {
        setArtists(responseData.Artists.map(x => ({
          Id: x.ArtistId,
          Image: x.Image,
          Object: {
            Slug: x.Slug
          },
          Result: x.Name
        })));
      },
      function () {
        setArtists([]);
      }
    );
  }

  return <div className="container">{artists.map((x, i) => <ArtistSearchResult key={i} d={x} />)}</div>;
}

export default Trending;